/* eslint-disable */
import session from './session';

export default {
    getRegionList(filter) {
        return session.get(`address/state/${filter}`);
    },
    getRegion(id) {
        return session.get(`address/state/${id}/`);
    },
    deleteRegion(id) {
        return session.delete(`address/state/${id}/`);
    },
    createRegion(data) {
        return session.post(`address/state/`, data);
    },
    updateRegion(id, data) {
        return session.patch(`address/state/${id}/`, data );
    },
};